import { render } from "./DetailsModalForm.vue?vue&type=template&id=65c6e4c4&ts=true"
import script from "./DetailsModalForm.vue?vue&type=script&lang=ts"
export * from "./DetailsModalForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__